<template lang="pug">
.profile
  .col-md-12
    .cover(:style="{backgroundImage: 'url(' + getCover() + ')'}" v-if='getCover()')
    .cover(:style="{backgroundImage: 'url(' + require('@/assets/images/faces/default-cover.png') + ')'}" v-else)
    .edit-cover(:style="{backgroundImage: 'url(' + require('@/assets/images/faces/ic_camera.svg') + ')'}" @click="changeAvatar(false)")
    .profile-content
      .card-avatar
        img(src='../../assets/images/faces/ic_AvatarDefault.svg' v-if='!getAvatar()')
        img(:src='user.avatar', v-else)
      .edit-avatar
        img(src="../../assets/images/faces/ic_camera.svg" @click="changeAvatar(true)")
      .content
        .hat-teacher
          .img-fullname(v-if="user.type_user === 2")
            img(src='../../assets/images/faces/ic_giaovien.svg')
          .fullname(:style="user.type_user === 2 ? 'padding-left: 10px;' : ''") {{user.fullname}}
        .userquotes {{user.userquotes}}
</template>


<script>
import changeAvatarModal from './changeAvatar'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
export default {
  props: {
    user: Object
  },
  data() {
    return {
      avt: null
    }
  },
  methods: {
    getCover() {
      if (this.user.cover) {
        return this.user.cover
      } else {
        return false
        // return 'https://hdwallpaperim.com/wp-content/uploads/2017/09/07/466505-your_name.-kimi_no_na_wa.jpg'
      }
    },
    getAvatar() {
      if (this.user.avatar) {
        return true
      } else {
        return false
      }
    },
    changeAvatar(flag) {
      if (flag) {
        this.$modal.show(changeAvatarModal, {
          title: 'ĐỔI AVATAR',
          user: this.user,
          saveFunction: this.onAvatarChange
        }, {
          height: 'auto',
          classes: ['col-6'],
          adaptive: true,
          resize: true,
          clickToClose: false
        })
      } else {
        this.$modal.show(changeAvatarModal, {
          title: 'ĐỔI ẢNH BÌA',
          user: this.user,
          saveFunction: this.changeCover
        }, {
          height: 'auto',
          classes: ['col-6'],
          adaptive: true,
          resize: true,
          clickToClose: false
        })
      }
    },
    async onAvatarChange(res) {
      // console.log(res)
      if (res.lstAvt.length > 0) {
        let directory = 'images/avatars'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < res.lstAvt.length; index++) {
          let avt = res.lstAvt[index]
          let file = avt.file
          // let fileName = avt.name.split('.')[0].replace(/ /g, '')
          let arrFileName = avt.name.split('.')
          let tagImage = arrFileName[arrFileName.length - 1]
          // console.log(tagImage, arrFileName)
          let fileName = 'avatar_upload.' + tagImage
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          await S3Client.uploadFile(file, fieldName).then((data) => {
            // console.log(data)
            this.avt = data.location
          })
        }
      }
      // Update avatar
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_AVATAR),
        variables: {
          uid: res.id,
          avatar: this.avt
        }
      }).then((res) => {
        this.$emit('onUpdateAvatar', res)
      }).catch((e) => {
        // Error
        console.error(e)
      })
    },
    async changeCover(res) {
      // console.log(res)
      if (res.lstAvt.length > 0) {
        let directory = 'images/avatars'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < res.lstAvt.length; index++) {
          let avt = res.lstAvt[index]
          let file = avt.file
          // let fileName = avt.name.split('.')[0].replace(/ /g, '')
          let arrFileName = avt.name.split('.')
          let tagImage = arrFileName[arrFileName.length - 1]
          // console.log(tagImage, arrFileName)
          let fileName = 'cover_upload.' + tagImage
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          await S3Client.uploadFile(file, fieldName).then((data) => {
            // console.log(data)
            this.cover = data.location
          })
        }
      }
      // Update avatar
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_COVER),
        variables: {
          uid: res.id,
          cover: this.cover
        }
        // update: (store, { data: { updateAvatar } }) => {
        //   // Read the data from our cache for this query.
        //   const data = store.readQuery({
        //     query: gql(graphql.GET_PROFILE),
        //     variables: { uid: res.id }
        //   })
        //   var userUpdated = data.users[0]
        //   userUpdated.cover = this.cover
        //   store.writeQuery({ query: gql(graphql.GET_PROFILE), data })
        // }
      }).then((res) => {
        this.$emit('onUpdateAvatar', res)
      }).catch((e) => {
        // Error
        console.error(e)
      })
    }
  }
}
</script>
<style lang="scss">
.edit-cover {
  background-size: cover;
  width: 32px !important;
  height: 32px !important;
  margin-top: -40px;
  position: absolute;
  right: 25px;
  z-index: 1000;
  cursor: pointer;
}
.profile{
  .cover{background-repeat: no-repeat; background-position: center;}
}
.profile-content {
  position: relative;
  z-index: 100;
  .card-avatar{
    margin-bottom:15px; 
    width: 160px !important; 
    height: 160px !important;
    margin: -50px auto 0;
    position: relative;
    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      // padding: 15px; // cho thấy full picture nhỏ bên trong viền tròng
    }
  }
  .edit-avatar {
    // height: 40px;
    cursor: pointer;
    left: 50%;
    position: absolute;
    margin-top: -30px;
    margin-left: 45px;
    width: 32px;
    height: 32px;
    img {
      max-width: 100%;
		  height: auto;
    }
  }
  .content {
    .hat-teacher {
      .img-fullname {
        width: 26px;
        display: inline-block;
        position: relative;
        top: -4px;
        img { max-width: 100%;width: 100%;height: auto;}
      }
      .fullname {
        white-space: nowrap;
        display: inline-block; 
        padding-top: 15px;
        font-family: 'adobe-clean', sans-serif;
        font-weight: bold;
        font-size: 20px;
        color: #4B2D15;
        opacity: 1;
      }
    }
    .userquotes {
      font-family: 'adobe-clean', sans-serif;
      font-size: 14px;
      color: #000000 !important;
      opacity: 1;
      padding: 10px 0;
    }
  }
}
@media (max-width: 991px) {
  .edit-avatar {
    margin-top: -40px !important;
    margin-left: 20px !important;
  }
}
@media (max-width: 768px) {
  .edit-avatar {
    margin-top: -30px !important;
    margin-left: 45px !important;
  }
}
@media (max-width: 560px) {
  .card-avatar {
    margin: -25px auto 0 !important;
  }
  .edit-cover {
    margin-top: -40px; // top right bottom left
  }
  .edit-avatar {
    margin-top: -30px !important;
    margin-left: 45px !important;
  }
}

@media only screen 
    and (min-device-width : 375px) 
    and (max-device-width : 812px)  { 
  .cover {
    width: 100%! important;
    height: 18vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 736px) 
  and (-webkit-min-device-pixel-ratio: 3) { 
  .cover {
    width: 100%! important;
    height: 18vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
    and (device-width : 360px) 
    and (device-height : 640px)  { 
  .cover {
    width: 100%! important;
    height: 18vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
  and (device-width: 375px) 
  and (device-height: 812px) 
  and (-webkit-min-device-pixel-ratio: 3) { 
  .cover {
    width: 100%! important;
    height: 15vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
  and (device-width: 768px) 
  and (device-height: 1024px)  { 
  .cover {
    width: 100%! important;
    height: 25vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 5%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
  and (device-width: 411px) 
  and (device-height: 823px)  { 
  .cover {
    width: 100%! important;
    height: 16vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}

@media only screen 
  and (device-width: 320px) 
  and (device-height: 568px)  { 
  .cover {
    width: 100%! important;
    height: 18vh! important;
  }
  .card-avatar {
    width: 30%! important;
    height: 30%! important;
  }
  .profile-content {
    margin-top: 4%! important;
  }
  // .edit-avatar {
  //   margin-left: 55%! important;
  // }
}
</style>



// WEBPACK FOOTER //
// avatar.vue?4bcbdca6